import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import type {
  APIUserResponse,
  GetAPIKeysSuccessPayload,
} from 'src/queries/organizations/apikeys.queries'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getAPIUser = async (): Promise<APIUserResponse> =>
  getResponseData(
    axios.get<APIUserResponse>(
      `/apikeys/users/`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getAPIKeys = async (): Promise<GetAPIKeysSuccessPayload> =>
  getResponseData(
    axios.get<GetAPIKeysSuccessPayload>(
      `/apikeys/`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
